import { faMessages } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { FeatureGuard } from "../../components/Routes/Guards/FeatureGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { Features } from "../feature.enum";
import { IFeature } from "../iFeature";
import { ChatBotPage } from "./ChatBotPage";
import { ChatThreadHistory } from "./ChatThreadHistory";

export const chatBotFeature: IFeature = {
  id: Features.ChatBot,
  route: {
    path: RouteConstants.Chatbot,
    element: (
      <FeatureGuard role={AppRole.ChatbotFeature}>
        <ChatBotPage />
      </FeatureGuard>
    ),
  },
  menuItem: {
    label: translationKeys.feature.chatbot.link,
    breadCrumbTitle: translationKeys.feature.chatbot.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Chatbot].join("/")}`,
    path: RouteConstants.Chatbot,
    showFooter: true,
    hasSideBar: stores => stores.settingsStore.persistChat,
    sidebarComponent: () => <ChatThreadHistory />,
    showSidebarTooltipKey: translationKeys.feature.chatbot.tooltips.showChatHistory,
    hideSidebarTooltipKey: translationKeys.feature.chatbot.tooltips.hideChatHistory,
    icon: () => <FontAwesomeIcon icon={faMessages} />,
  },
  card: (
    <FeatureCard
      featureKey={Features.ChatBot}
      requiresBudget={true}
      featureIcon={faMessages}
      buttonIcon={faMessages}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Chatbot}
    />
  ),
  role: AppRole.ChatbotFeature,
};
